import type { incomingNavbarItemsInterface } from "./incomingInterface";
import type { navbarInterface } from "./interface";

export const mockData2: incomingNavbarItemsInterface = {
  isDas: false,
  programs: "RETAIL",
  toggleBrandHtml: "",
  dealerDisplayName: "5 Star Auto Mall Suzuki - INTERNAL DEV Env Test Acct",
  locales: [{ locale: "en_US", name: "English" }],
  accountSwitcher: {
    label: "Switch Account",
    url: "/{app}/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/userMenu/loadAccountInfo?cachebust=f842b44f031238c3"
  },
  sessionId: "f842b44f031238c3",
  env: "qa",
  links: {
    applications:
      "/commoncontainer/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/applications?cachebust=f842b44f031238c3",
    navigation:
      "/{app}/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/navigation?cachebust=f842b44f031238c3&lang=en_US"
  },
  cc8Navigation: {
    "links-menu": [
      {
        links: [
          {
            label: "Welcome",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin"
          }
        ]
      },
      {
        label: "ANALYZE",
        links: [
          {
            label: "Analytics",
            links: [
              {
                label: "Detailed Reports",
                link: "https://apps.dealercenter-np.coxautoinc.com/analytics/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/report/index?lang=en_US&lang=en_US"
              },
              {
                label: "Report Scheduler",
                link: "https://apps.dealercenter-np.coxautoinc.com/analytics/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/scheduler/index"
              }
            ],
            "application-key": "analytics"
          }
        ]
      },
      {
        label: "MANAGE",
        links: [
          {
            "application-key": "leads",
            label: "Leads",
            links: [
              {
                label: "Advertising Sources",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/advertisingsources"
              },
              {
                label: "Configuration",
                links: [
                  {
                    label: "Lead Distribution",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/leaddistribution"
                  },
                  {
                    label: "Auto Responders",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/autoresponders"
                  },
                  {
                    label: "Lead Lifecycles",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/leadlifecycles"
                  },
                  {
                    label: "Import Contacts",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/import/contacts"
                  }
                ]
              },
              {
                label: "All Leads",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#all"
              },
              {
                label: "Website Forms",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#websiteforms"
              },
              {
                label: "Phone Calls",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#phonecalls"
              },
              {
                label: "3rd Party",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#thirdparty"
              },
              {
                label: "Walk In",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#walkin"
              },
              {
                label: "Address Book",
                links: [
                  {
                    label: "Active",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#active"
                  },
                  {
                    label: "Deleted",
                    link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/nav/index#deleted"
                  }
                ]
              }
            ]
          },
          {
            "application-key": "website",
            label: "Website",
            links: [
              {
                label: "Blog",
                links: [
                  {
                    label: "Dashboard",
                    link: "https://apps.dealercenter-np.coxautoinc.com/website/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/blog/index#dashboard"
                  }
                ],
                type: "sub-section"
              },
              {
                label: "MyCars",
                links: [
                  {
                    label: "Group Memberships",
                    link: "https://apps.dealercenter-np.coxautoinc.com/website/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/myCarsGroupMemberships"
                  }
                ],
                type: "sub-section"
              },
              {
                label: "Viewing As",
                links: [
                  {
                    label: "mjdell",
                    link: "javascript:void(userSelector.viewingAsInternal())"
                  },
                  {
                    label: "5starautomallsuzukiinternaldevenvtestacct-admin",
                    link: "javascript:void(userSelector.viewingAsExternal())"
                  }
                ],
                type: "sub-section"
              }
            ]
          },
          {
            label: "Inventory",
            links: [
              {
                label: "Vehicles",
                links: [
                  {
                    label: "Inventory Lifecycles",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/i/index#lifecycle~summary"
                  },
                  {
                    label: "Edit Inventory",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/index#automotive"
                  },
                  {
                    label: "Window Stickers",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/i/index#vehicle~stickers"
                  }
                ]
              },
              {
                label: "Incentives",
                links: [
                  {
                    label: "Incentives Manager",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/market/incentivesmanager"
                  },
                  {
                    label: "Incentive Feeds",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/incentive/manage"
                  },
                  {
                    label: "Incentive Configuration",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/incentive/configure"
                  }
                ]
              },
              {
                label: "Video",
                links: [
                  {
                    label: "CarFlix Configuration",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/carflix"
                  },
                  {
                    label: "CarFlix Management",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/carflixRegen/index"
                  }
                ]
              },
              {
                label: "Exports",
                links: [
                  {
                    label: "Exported Inventory",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/market/inventoryexports"
                  },
                  {
                    label: "Craigslist",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/i/index#vehicle~craigslist"
                  }
                ]
              },
              {
                label: "Configure",
                links: [
                  {
                    label: "General",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/general"
                  },
                  {
                    label: "Vehicle Options",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/configure/vehicleoptions"
                  },
                  {
                    label: "Health Score",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/healthScore/index"
                  },
                  {
                    label: "Inbound Feeds",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/publishRules/index"
                  },
                  {
                    label: "Inventory Refresh",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/solrRefresh/index"
                  },
                  {
                    label: "DR Tools",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/drBatch/index"
                  },
                  {
                    label: "Vin-Incentive Refresh",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/vinIncentiveRefresh/index"
                  },
                  {
                    label: "Incentive Configuration",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/incentive/configure"
                  }
                ]
              }
            ],
            "application-key": "inventory"
          },
          {
            label: "Media & Specials",
            links: [
              {
                label: "SpecialsBuilder PRO",
                links: [
                  {
                    label: "Manage Specials",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/specialsbuilder/index"
                  },
                  {
                    label: "Specials Report",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/specialsbuilder/report"
                  },
                  {
                    label: "Dealer.com",
                    links: [
                      {
                        label: "Media Library"
                      },
                      {
                        label: "PowerMail Templates"
                      },
                      {
                        label: "PowerMail Signatures"
                      }
                    ]
                  },
                  {
                    label: "Autotrader",
                    links: [
                      {
                        label: "Multimedia Library"
                      }
                    ]
                  }
                ]
              },
              {
                label: "Media",
                links: [
                  {
                    label: "Media Library",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/medialibrary3/index"
                  },
                  {
                    label: "PowerMail Templates",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/powermail/templates"
                  },
                  {
                    label: "PowerMail Signatures",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/powermail/signatures"
                  }
                ]
              },
              {
                label: "Specials Campaigns",
                links: [
                  {
                    label: "Manage",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manager/index#/manage"
                  },
                  {
                    label: "Create",
                    link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manager/index#/create"
                  }
                ]
              }
            ],
            "application-key": "promotions"
          },
          {
            label: "Social Media",
            links: [
              {
                label: "Syndicate",
                links: [
                  {
                    label: "SmartBlog Compose",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/post/add"
                  },
                  {
                    label: "Approval Queue",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/socialSyndication/approvalQueue"
                  },
                  {
                    label: "Posts",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/socialSyndication/posts"
                  },
                  {
                    label: "Calendar",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/socialSyndication/calendar"
                  }
                ]
              },
              {
                label: "Configure",
                links: [
                  {
                    label: "Approval",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/socialSyndication/approvalConfig"
                  },
                  {
                    label: "Social Networks",
                    link: "https://apps.dealercenter-np.coxautoinc.com/social/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/socialSyndication/networkConfig"
                  }
                ]
              }
            ],
            "application-key": "social"
          },
          {
            label: "Configuration",
            links: [
              {
                label: "Manage Your User Information",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/myinfo"
              },
              {
                label: "Company Information",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/companyinfo"
              },
              {
                label: "Manage Your Users",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/users"
              },
              {
                label: "Phone Manager",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/phonenumbers"
              },
              {
                label: "Merchandising Settings"
              },
              {
                label: "Service Advisor"
              }
            ],
            "application-key": "configuration"
          },
          {
            label: "Marketplace",
            links: [
              {
                label: "MarketPlace",
                link: "https://apps.dealercenter-np.coxautoinc.com/marketplace/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/dashboard/index"
              },
              {
                label: "Account Overview",
                link: "https://apps.dealercenter-np.coxautoinc.com/marketplace/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/accountOverview/index"
              }
            ],
            "application-key": "marketplace"
          }
        ]
      },
      {
        links: [
          {
            label: "Tutorials",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/tutorials/index"
          },
          {
            link: "https://www.coxautoinc.com/privacy-statement/",
            label: "Privacy & Legal",
            "new-tab": true
          },
          { label: "Terms", "new-tab": true },
          {
            link: "https://www.coxautoinc.com/terms/wp-content/uploads/sites/3/Common-Customer-TOU.pdf",
            label: "Terms of Use",
            "new-tab": true
          }
        ]
      }
    ],
    "user-menu": [
      {
        initials: "DD",
        name: "Dealer.com Support DO NOT DELETE",
        "service-account": {
          name: "5 Star Auto Mall Suzuki - INTERNAL DEV Env Test Acct",
          state: "NC"
        }
      },
      {
        links: [
          {
            label: "Quick Links",
            links: [
              {
                label: "Manage Your Inventory",
                link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin"
              },
              {
                label: "View Your Leads",
                link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin"
              },
              {
                label: "Manage Your Website",
                link: "https://apps.dealercenter-np.coxautoinc.com/website/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin"
              },
              {
                label: "Manage Your Users",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/users"
              },
              {
                label: "Manage Your User Information",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/manage/myinfo"
              }
            ]
          },
          {
            label: "Your Team",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/yourteam"
          },
          {
            label: "Tutorials",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/tutorials/index"
          }
        ]
      },
      {
        links: [
          {
            label: "Sign Out",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/5starautomallsuzukiinternaldevenvtestacct/5starautomallsuzukiinternaldevenvtestacct-admin/logout",
            "callback-class": "btn btn-primary"
          }
        ]
      }
    ]
  },
  bridgeUserCode: "IS_BRIDGE_2"
};

export const mockData: incomingNavbarItemsInterface = {
  isDas: false,
  programs: "RETAIL",
  toggleBrandHtml: "",
  bridgeUserCode: "IS_BRIDGE_2",
  dealerDisplayName: "Dealer.com",
  locales: [
    {
      locale: "en_US",
      name: "English"
    }
  ],
  accountSwitcher: {
    label: "Switch Account",
    url: "/{app}/userMenu/loadAccountInfo?cachebust=e655547328d14db3"
  },
  sessionId: "e655547328d14db3",
  env: "qa",
  links: {
    applications: "/commoncontainer/applications?cachebust=e655547328d14db3",
    navigation: "/{app}/navigation?cachebust=e655547328d14db3&lang=en_US"
  },
  cc8Navigation: {
    "links-menu": [
      {
        links: [
          {
            label: "Welcome",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome"
          }
        ]
      },
      {
        label: "ANALYZE",
        links: [
          {
            label: "Analytics",
            links: [
              {
                label: "Detailed Reports",
                link: "https://apps.dealercenter-np.coxautoinc.com/analytics/report?lang=en-US&lang=en-US"
              },
              {
                label: "Report Scheduler",
                link: "https://apps.dealercenter-np.coxautoinc.com/analytics/scheduler/index"
              }
            ],
            "application-key": "analytics"
          }
        ]
      },
      {
        label: "MANAGE",
        links: [
          {
            "application-key": "leads",
            label: "Leads",
            links: [
              {
                label: "Advertising Sources",
                link: "https://apps.dealercenter-np.coxautoinc.com/advertising/configure/advertisingsources"
              }
            ]
          },
          {
            label: "Inventory",
            links: [
              {
                label: "Configure",
                links: [
                  {
                    label: "Inbound Feeds",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/publishRules/index"
                  },
                  {
                    label: "Inventory Refresh",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/solrRefresh/index"
                  },
                  {
                    label: "DR Tools",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/drBatch/index"
                  },
                  {
                    label: "Vin-Incentive Refresh",
                    link: "https://apps.dealercenter-np.coxautoinc.com/inventory/vinIncentiveRefresh/index"
                  }
                ]
              }
            ],
            "application-key": "inventory"
          },
          {
            label: "Configuration",
            links: [
              {
                label: "Manage Your User Information",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/manage/myinfo"
              }
            ],
            "application-key": "configuration"
          },
          {
            label: "Marketplace",
            links: [
              {
                label: "MarketPlace",
                link: "https://apps.dealercenter-np.coxautoinc.com/marketplace/"
              },
              {
                label: "Account Overview",
                link: "https://apps.dealercenter-np.coxautoinc.com/marketplace/accountOverview/index"
              }
            ],
            "application-key": "marketplace"
          }
        ]
      },
      {
        links: [
          {
            label: "TUTORIALS",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/tutorials/index"
          },
          {
            link: "https://www.coxautoinc.com/privacy-statement/",
            label: "Privacy & Legal",
            "new-tab": true
          },
          {
            label: "Terms",
            "new-tab": true
          },
          {
            link: "https://www.coxautoinc.com/terms/wp-content/uploads/sites/3/Common-Customer-TOU.pdf",
            label: "Terms of Use",
            "new-tab": true
          }
        ]
      }
    ],
    "user-menu": [
      {
        initials: "MD",
        name: "Mark Dell",
        "service-account": {
          name: "Dealer.com"
        }
      },
      {
        links: [
          {
            label: "Quick Links",
            links: [
              {
                label: "Manage Your Inventory",
                link: "https://apps.dealercenter-np.coxautoinc.com/inventory"
              },
              {
                label: "Manage Your Campaigns",
                link: "https://apps.dealercenter-np.coxautoinc.com/advertising"
              },
              {
                label: "Manage Your User Information",
                link: "https://apps.dealercenter-np.coxautoinc.com/configuration/manage/myinfo"
              }
            ]
          },
          {
            label: "Your Team",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/yourteam"
          },
          {
            label: "TUTORIALS",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/tutorials/index"
          }
        ]
      },
      {
        links: [
          {
            label: "Sign Out",
            link: "https://apps.dealercenter-np.coxautoinc.com/welcome/logout",
            "callback-class": "btn btn-primary"
          }
        ]
      }
    ]
  }
};

export const mockWithoutAccount: navbarInterface = {
  programs: "",
  links: {
    applications: "",
    navigation: ""
  },
  linksMenu: [
    {
      label: "INTERNAL",
      linkType: "header"
    },
    {
      label: "Account Search",
      link: "/account-search",
      linkType: "navigate"
    },
    {
      label: "User Search",
      link: "/userSearch",
      linkType: "navigate"
    },
    {
      label: "VIN Decode",
      link: "/vin-decode",
      linkType: "navigate"
    },
    {
      label: "Dealer Codes",
      link: "/dealer-codes",
      linkType: "navigate"
    },
    {
      label: "Import/Export Local Storage",
      link: "/import-export",
      linkType: "navigate"
    }
  ],
  usermenu: {
    user: {},
    nav: []
  }
};

export const mockWithAccount: navbarInterface = {
  programs: "forddirect",
  links: {
    applications:
      "/commoncontainer/as/forddirect/forddirect-admin/applications?cachebust=3a23dd79cb75293c",
    navigation:
      "/{app}/as/forddirect/forddirect-admin/navigation?cachebust=3a23dd79cb75293c&lang=en_US"
  },
  linksMenu: [
    {
      label: "INTERNAL",
      linkType: "header"
    },
    {
      label: "Account Search",
      link: "/account-search",
      linkType: "navigate"
    },
    {
      label: "User Search",
      link: "/userSearch",
      linkType: "navigate"
    },
    {
      label: "VIN Decode",
      link: "/vin-decode",
      linkType: "navigate"
    },
    {
      label: "Dealer Codes",
      link: "/dealer-codes",
      linkType: "navigate"
    },
    {
      label: "Import/Export Local Storage",
      link: "/import-export",
      linkType: "navigate"
    },
    {
      label: "Welcome",
      linkType: "navigate",
      link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/forddirect/forddirect-admin"
    },
    {
      label: "ANALYZE",
      linkType: "header"
    },
    {
      label: "nVision Analyze",
      linkType: "open",
      link: "https://nvision-qa.coxautoinc.com/analytics/as/forddirect/forddirect-admin/report/index"
    },
    {
      label: "MANAGE",
      linkType: "header"
    },
    {
      label: "Leads",
      links: [
        {
          label: "Advertising Sources",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/configure/advertisingsources",
          linkType: "navigate"
        },
        {
          label: "Configuration",
          links: [
            {
              label: "Lead Distribution",
              link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/configure/leaddistribution",
              linkType: "navigate"
            },
            {
              label: "Auto Responders",
              link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/configure/autoresponders",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "All Leads",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#all",
          linkType: "navigate"
        },
        {
          label: "Website Forms",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#websiteforms",
          linkType: "navigate"
        },
        {
          label: "Phone Calls",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#phonecalls",
          linkType: "navigate"
        },
        {
          label: "3rd Party",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#thirdparty",
          linkType: "navigate"
        },
        {
          label: "Walk In",
          link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#walkin",
          linkType: "navigate"
        },
        {
          label: "Address Book",
          links: [
            {
              label: "Active",
              link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#active",
              linkType: "navigate"
            },
            {
              label: "Deleted",
              link: "https://apps.dealercenter-np.coxautoinc.com/leads/as/forddirect/forddirect-admin/nav/index#deleted",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Website",
      links: [
        {
          label: "Website Editor",
          link: "https://forddirect.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index#website",
          linkType: "open"
        },
        {
          label: "Configure Website Integrations",
          link: "https://apps.dealercenter-np.coxautoinc.com/website/as/forddirect/forddirect-admin/webIntegrations/index",
          linkType: "navigate"
        },
        {
          label: "Landing Pages",
          link: "https://forddirect.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index#mslp",
          linkType: "open"
        },
        {
          label: "Page Sets",
          link: "https://forddirect.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index#features",
          linkType: "open"
        },
        {
          label: "Configuration",
          link: "https://forddirect.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index#configuration",
          linkType: "open"
        },
        {
          label: "Profile Site",
          links: [
            {
              label: "Website Editor",
              link: "https://fordprofile.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index?relation=profile&relatedSite=true&relatedSiteId=forddirect#website",
              linkType: "open"
            },
            {
              label: "Configure Website Integrations",
              link: "https://apps.dealercenter-np.coxautoinc.com/website/as/forddirect/forddirect-admin/webIntegrations/index?relation=profile&siteId=fordprofile",
              linkType: "navigate"
            },
            {
              label: "Landing Pages",
              link: "https://fordprofile.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index?relation=profile&relatedSite=true&relatedSiteId=forddirect#mslp",
              linkType: "open"
            },
            {
              label: "Page Sets",
              link: "https://fordprofile.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index?relation=profile&relatedSite=true&relatedSiteId=forddirect#features",
              linkType: "open"
            },
            {
              label: "Configuration",
              link: "https://fordprofile.website.dealercenter-np.coxautoinc.com/cc-website/as/forddirect/forddirect-admin/composer/index?relation=profile&relatedSite=true&relatedSiteId=forddirect#configuration",
              linkType: "open"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Distribution List Manager",
          link: "https://apps.dealercenter-np.coxautoinc.com/website/as/forddirect/forddirect-admin/distributionList/index",
          linkType: "navigate"
        },
        {
          label: "Blog",
          links: [
            {
              label: "Dashboard",
              link: "https://apps.dealercenter-np.coxautoinc.com/website/as/forddirect/forddirect-admin/blog/index#dashboard",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Viewing As",
          links: [
            {
              label: "mjdell",
              link: "javascript:void(userSelector.viewingAsInternal())",
              linkType: "open"
            },
            {
              label: "forddirect-admin",
              link: "javascript:void(userSelector.viewingAsExternal())",
              linkType: "open"
            }
          ],
          linkType: "parent"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Inventory",
      links: [
        {
          label: "Vehicles",
          links: [
            {
              label: "Inventory Lifecycles",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/i/index#lifecycle~summary",
              linkType: "navigate"
            },
            {
              label: "Inventory Manager",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/im10/index",
              linkType: "navigate"
            },
            {
              label: "Price Configuration",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/priceConfig/index",
              linkType: "navigate"
            },
            {
              label: "Window Stickers",
              link: 'https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/im10/index?search={"lookfilter":"STICKERS"}',
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Incentives",
          links: [
            {
              label: "Incentives Manager",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/market/incentivesmanager",
              linkType: "navigate"
            },
            {
              label: "Incentive Feeds",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/incentive/manage",
              linkType: "navigate"
            },
            {
              label: "Incentive Configuration",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/incentive/configure",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Video",
          links: [
            {
              label: "CarFlix Configuration",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/configure/carflix",
              linkType: "navigate"
            },
            {
              label: "CarFlix Management",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/carflixRegen/index",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Exports",
          links: [
            {
              label: "Exported Inventory",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/market/inventoryexports",
              linkType: "navigate"
            },
            {
              label: "Craigslist",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/i/index#vehicle~craigslist",
              linkType: "navigate"
            },
            {
              label: "Ebay Auctions",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/market/ebayauctions",
              linkType: "navigate"
            },
            {
              label: "Ebay Configuration",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/configure/ebayConfiguration",
              linkType: "navigate"
            },
            {
              label: "Ebay Templates",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/configure/ebayTemplates",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Configure",
          links: [
            {
              label: "General",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/configure/general",
              linkType: "navigate"
            },
            {
              label: "Vehicle Options",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/configure/vehicleoptions",
              linkType: "navigate"
            },
            {
              label: "Health Score",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/healthScore/index",
              linkType: "navigate"
            },
            {
              label: "Shot Profiles",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/shotProfiles/index",
              linkType: "navigate"
            },
            {
              label: "Inbound Feeds",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/publishRules/index",
              linkType: "navigate"
            },
            {
              label: "Inventory Refresh",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/solrRefresh/index",
              linkType: "navigate"
            },
            {
              label: "Vin-Incentive Refresh",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/vinIncentiveRefresh/index",
              linkType: "navigate"
            },
            {
              label: "Incentive Configuration",
              link: "https://apps.dealercenter-np.coxautoinc.com/inventory/as/forddirect/forddirect-admin/incentive/configure",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Media & Specials",
      links: [
        {
          label: "Media",
          links: [
            {
              label: "Media Library",
              link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/forddirect/forddirect-admin/medialibrary3",
              linkType: "navigate"
            },
            {
              label: "PowerMail Templates",
              link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/forddirect/forddirect-admin/powermail/templates",
              linkType: "navigate"
            },
            {
              label: "PowerMail Signatures",
              link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/forddirect/forddirect-admin/powermail/signatures",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        },
        {
          label: "Specials Campaigns",
          links: [
            {
              label: "Manage",
              link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/forddirect/forddirect-admin/manager/index#/manage",
              linkType: "navigate"
            },
            {
              label: "Create",
              link: "https://apps.dealercenter-np.coxautoinc.com/promotions/as/forddirect/forddirect-admin/manager/index#/create",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Social Media",
      links: [
        {
          label: "Syndicate",
          links: [
            {
              label: "SmartBlog Compose",
              link: "https://apps.dealercenter-np.coxautoinc.com/social/as/forddirect/forddirect-admin/post/add",
              linkType: "navigate"
            },
            {
              label: "Posts",
              link: "https://apps.dealercenter-np.coxautoinc.com/social/as/forddirect/forddirect-admin/socialSyndication/posts",
              linkType: "navigate"
            },
            {
              label: "Calendar",
              link: "https://apps.dealercenter-np.coxautoinc.com/social/as/forddirect/forddirect-admin/socialSyndication/calendar",
              linkType: "navigate"
            }
          ],
          linkType: "parent"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Configuration",
      links: [
        {
          label: "Manage Your User Information",
          link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/forddirect/forddirect-admin/manage/myinfo",
          linkType: "navigate"
        },
        {
          label: "Company Information",
          link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/forddirect/forddirect-admin/manage/companyinfo",
          linkType: "navigate"
        },
        {
          label: "Manage Your Users",
          link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/forddirect/forddirect-admin/manage/users",
          linkType: "navigate"
        },
        {
          label: "Phone Manager",
          link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/forddirect/forddirect-admin/manage/phonenumbers",
          linkType: "navigate"
        },
        {
          label: "Lead Notifications",
          link: "https://apps.dealercenter-np.coxautoinc.com/configuration/as/forddirect/forddirect-admin/leadNotifications/index",
          linkType: "navigate"
        }
      ],
      linkType: "parent"
    },
    {
      label: "Tutorials",
      linkType: "navigate",
      link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/forddirect/forddirect-admin/tutorials/index"
    }
  ],
  usermenu: {
    user: {
      name: "Dealer.com Support DO NOT DELETE"
    },
    nav: [
      {
        label: "Sign Out",
        linkType: "navigate",
        link: "https://apps.dealercenter-np.coxautoinc.com/welcome/as/forddirect/forddirect-admin/logout"
      }
    ]
  }
};
